<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Toggle, Container } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { real_id } from 'src/helpers/interface_helpers';
	//Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Stores
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	//Svelte hooks
	import { onMount } from 'svelte';
	import SettingGuide from '../../../SettingGuide.svelte';

	export let device;
	export let title = '';

	let inputsSettings = {};
	let id = real_id(device.id),
		settings = readDeviceSettings(id),
		loading = {},
		cache;

	const getSettings = () => {
		Object.keys(settings).forEach((setting) => {
			if (setting.includes('input:') && Number(setting.split(':')[1]) < 100) {
				inputsSettings[setting.split(':')[1]] = settings[setting].invert;
				loading[setting.split(':')[1]] = false;
			}
		});
		cache = Object.assign({}, inputsSettings);
	};

	const sentRequest = async (inputChannel, event) => {
		inputsSettings[inputChannel] = event.target.checked;
		if (cache[inputChannel] !== inputsSettings[inputChannel]) {
			loading[inputChannel] = true;
			const res: SettingRequest = await gen2Request(device, 'Input.SetConfig', {
				id: inputChannel,
				config: { invert: inputsSettings[inputChannel] },
			});

			const response = onSettingsResponse(res, device);
			if (response) {
				settings[`input:${inputChannel}`].invert = inputsSettings[inputChannel];
				devices_settings.update_devices_settings(id, settings);
				cache = Object.assign({}, inputsSettings);
			} else {
				inputsSettings = Object.assign({}, cache);
			}
			loading[inputChannel] = false;
		}
	};

	onMount(() => {
		getSettings();
	});
</script>

<SettingGuide
	{title}
	text={$format('settings_guide_invert_switch', {
		default:
			'Swap which switch position is on and which is off, so the wall switch matches how it is wired.',
	})}
/>

{#each Object.keys(inputsSettings) as input, i}
	<Container padding="xs" class="mb-s">
		<Toggle
			checked={inputsSettings[input]}
			disabled={loading[i]}
			on:click={(e) => sentRequest(i, e)}
			size="m"
			id="toggle-r25z6l6"
			>{$format('input_invert_desc_per_id', {
				default: `Enable invert for device input ${settings[`input:${i}`].name || i}`,
				values: { index: settings[`input:${i}`].name || i },
			})}</Toggle
		>
	</Container>
{/each}
